import { MeetingManager } from "amazon-chime-sdk-component-library-react";
import { streamTracker } from "./streamTracker";

/**
 * Stops all Chime SDK streams using the meeting manager
 * This is the proper way to stop streams managed by the Chime SDK
 */
export async function stopChimeStreams(meetingManager: MeetingManager | null): Promise<void> {
  if (!meetingManager) {
    console.log('No meeting manager available for stream cleanup');
    return;
  }

  try {
    console.log('Stopping Chime SDK streams...');

    // Stop video input
    try {
      await meetingManager.audioVideo.stopVideoInput();
      console.log('Video input stopped');
    } catch (videoError) {
      console.warn('Error stopping video input:', videoError);
    }

    // Stop audio input
    try {
      await meetingManager.audioVideo.stopAudioInput();
      console.log('Audio input stopped');
    } catch (audioError) {
      console.warn('Error stopping audio input:', audioError);
    }

    // Stop content share
    try {
      await meetingManager.audioVideo.stopContentShare();
      console.log('Content share stopped');
    } catch (contentError) {
      console.warn('Error stopping content share:', contentError);
    }

    // Stop all video tiles
    try {
      const videoTiles = meetingManager.audioVideo.getAllVideoTiles();
      for (const tile of videoTiles) {
        meetingManager.audioVideo.removeVideoTile(tile.tileId);
      }
      console.log('Video tiles removed');
    } catch (tileError) {
      console.warn('Error removing video tiles:', tileError);
    }

    console.log('Chime SDK streams stopped successfully');
  } catch (error) {
    console.error('Error stopping Chime SDK streams:', error);
  }
}

/**
 * Stops all tracked streams using the stream tracker
 * This is the most reliable method as it tracks actual streams
 */
export function stopAllTrackedStreams(): void {
  console.log('Stopping all tracked streams...');
  streamTracker.stopAllStreams();
}

/**
 * Force stops all media streams without creating new ones
 * This is a fallback method that only stops existing streams
 */
export function forceStopAllMediaStreams(): void {
  try {
    console.log('Force stopping all media streams...');

    // First try to stop tracked streams
    stopAllTrackedStreams();

    // No need to create new streams - just stop what we can track
    console.log('All tracked streams stopped (no new streams created)');
  } catch (error) {
    console.error('Error force stopping media streams:', error);
  }
}
